import script from "./AccueilViews.vue?vue&type=script&setup=true&lang=js"
export * from "./AccueilViews.vue?vue&type=script&setup=true&lang=js"

import "./AccueilViews.vue?vue&type=style&index=0&id=5fc0320d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc0320d"]])

export default __exports__